/**
 * Armazena as informações de servidor obtidas das variáveis de ambiente
 */
export class InfoServer {
    constructor(protocol, host, port, context, apiroot) {
        this._protocol = protocol;
        this._host = host;
        this._port = port;
        this._context = context;
        this._apiroot = apiroot;
    }
    set protocol(protocol) {
        this._protocol = protocol;
    }
    get protocol() {
        return this._protocol;
    }
    set port(port) {
        this._port = port;
    }
    get port() {
        return this._port;
    }
    set host(host) {
        this._host = host;
    }
    get host() {
        return this._host;
    }
    set context(context) {
        this._context = context;
    }
    get context() {
        return this._context;
    }
    set apiroot(apiroot) {
        this._apiroot = apiroot;
    }
    get apiroot() {
        return this._apiroot;
    }
}
